import { render, staticRenderFns } from "./SeriesAwardsTbl.vue?vue&type=template&id=7e76faec&scoped=true&"
import script from "./SeriesAwardsTbl.vue?vue&type=script&lang=js&"
export * from "./SeriesAwardsTbl.vue?vue&type=script&lang=js&"
import style0 from "./SeriesAwardsTbl.vue?vue&type=style&index=0&id=7e76faec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e76faec",
  null
  
)

export default component.exports